import * as React from 'react';
import {
  Stack
} from '@mui/material';

const NoRowsOverlay = () => (
  <Stack height="100%" alignItems="center" justifyContent="center">
    Sem registros
  </Stack>
);

export default NoRowsOverlay;
